module.exports = __webpack_public_path__ + "static/media/chevron-left.75a524e1.svg";